import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

/**
 * A way to ask for a new evaluation from outside the Risultati tab.
 *
 * `Result` owns request-poll-reload and has to keep owning it: a second runner
 * would poll the same evaluation twice and leave that tab showing a stale
 * score. So the rest of the page raises a request here and `Result` runs it,
 * rather than calling the endpoint directly.
 *
 * Component-scoped like the rest of the compiling state — one page, one answer.
 */
@Injectable()
export class EvaluationRequestService {
  private readonly requests = new Subject<void>();

  /** Emits each time something on the page asks for a new evaluation. */
  readonly requests$: Observable<void> = this.requests.asObservable();

  /** Asks the Risultati tab to start an evaluation. */
  request(): void {
    this.requests.next();
  }
}
